import { searchActionTypes } from "./search.types";
import { getAdaptedData } from "../../utils/dataAdapter";

export const changeSearchInputValue = inputValue => ({
	type: searchActionTypes.CHANGE_SEARCH_INPUT_VALUE,
	payload: inputValue
})

export const clearSearchInputValue = () => ({
	type: searchActionTypes.CLEAR_SEARCH_INPUT_VALUE
})

export const fetchSearchResultsRequest = searchQuery => ({
	type: searchActionTypes.FETCH_SEARCH_RESULTS_REQUEST,
	payload: searchQuery
})

export const fetchSearchResultsSuccess = searchResults => ({
	type: searchActionTypes.FETCH_SEARCH_RESULTS_SUCCESS,
	payload: searchResults
})

export const fetchSearchResultsFailure = errorMessage => ({
	type: searchActionTypes.FETCH_SEARCH_RESULTS_FAILURE,
	payload: errorMessage
})

export const fetchSearchResultsAsync = searchQuery => {
	return async dispatch => {
		dispatch(fetchSearchResultsRequest(searchQuery));
		try {
			const data = await getAdaptedData();
			const filteredResults = data.filter(result => result.name && result.name.toLowerCase().includes(searchQuery.toLowerCase()));
			dispatch(fetchSearchResultsSuccess(filteredResults));
		} catch (err) {
			dispatch(fetchSearchResultsFailure(err.message));
		}
	}
}